import(/* webpackMode: "eager" */ "/opt/app/[lng]/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/components/global/analytics/gtm-embed.tsx");
;
import(/* webpackMode: "eager" */ "/opt/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/node_modules/next/font/google/target.css?{\"path\":\"app/[lng]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"weight\":[\"100\",\"300\",\"400\",\"500\",\"700\",\"900\"]}],\"variableName\":\"inter\"}");
